module.exports = __webpack_public_path__ + "img/Plan de travail 34@2x-100.c1df512d.jpg";